import { BookingSearch } from '@common/interfaces/booking-search/booking-search.interface';

/**
 * BookingSearch model details
 */
export interface BookingSearchStateDetails {}

/**
 * BookingSearch store state
 */
export interface BookingSearchState extends BookingSearchStateDetails {
  model: BookingSearch | null;
}

/**
 * Name of the BookingSearch Store
 */
export const BOOKING_SEARCH_STORE_NAME = 'bookingSearch';

/**
 * BookingSearch Store Interface
 */
export interface BookingSearchStore {
  /** BookingSearch state */
  [BOOKING_SEARCH_STORE_NAME]: BookingSearchState;
}
